import * as React from "react"
import IInvoiceVm from "../../../models/home/Payment/IInvoiceVm"
import IParentBulkInvoiceVm from "../../../models/home/Payment/IParentBulkInvoiceVm"
import i18n from "../../../i18n/i18n"

interface IProps {
    invoice: IInvoiceVm | IParentBulkInvoiceVm
}

export default function ReceiptStep({
    invoice
}: IProps) {

    const GetHtmlContent= (invoice: IInvoiceVm) : string => {
        let html = ""

        if(invoice.receipt && invoice.receipt.html){
            html = invoice.receipt && invoice.receipt.html
        }
        else{
            html = "<p>Kvitteringen er desværre ikke klar endnu. Prøv at genindlæse denne side om 10 sekunder.</p>"
        }

        return html
    }

    const downloadReceiptButton = <a
        className="btn btn-blue"
        data-ui-test="download-receipt-button"
        href={process.env.SERVER + "Payment/DownloadInvoiceReceipt?receiptId=" + (invoice.receipt && invoice.receipt.id)}
        target="new">
        <i className="icon-file-alt" /> {i18n.t("TEXT_DOWNLOAD_RECEIPT_AS_PDF")}
    </a>

    const empty = <div></div>

    return (
        <div>
            <div className="confirmation" data-ui-test="payment-step-receipt" dangerouslySetInnerHTML={{ __html: GetHtmlContent(invoice) }}>
            </div>
            <hr />
            {invoice.receipt ? downloadReceiptButton : empty}
        </div>
    )
}